import { createApp } from "vue";
import { createPinia } from "pinia";
import { createGtm } from "@gtm-support/vue-gtm"

import App from "./App.vue";
import router from "./router";

import "./assets/scss/ress.css";
import "./assets/scss/icons.css";

const pinia = createPinia();
const app = createApp(App).use(pinia).use(router);

// GTMのIDが式場ごとに異なるため、あらかじめindex.htmlにIDを埋め込んでおいて取得する
const gtmElement = document.getElementById("gtm");
const { id } = gtmElement.dataset;
if (id) {
  const gtm = createGtm({
    id,                         // GTM_IDをいれる
    defer: false,               // ページの読み込みを高速化（トラッキング精度低下の可能性あり）
    debug: false,               // コンソールログのデバッグを表示するかどうか
    loadScript: true,           // GTMスクリプトを読み込むかどうか
    vueRouter: router,          // vueRouterと自動的に同期するインスタンスを設定
    ignoredViews: ['notFound'], // 指定したルーター名はトラッキングしない（例：404ページなど）
    trackOnNextTick: true       // Vue.nextTick で trackView を呼び出すかどうか
  });
  app.use(gtm);
}

app.mount("#app");
